import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const useChat = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.getHistory().then(setMessages).catch(() => {});
  }, []);

  const send = useCallback(async (text) => {
    setMessages((m) => [...m, { id: `tmp_${Date.now()}`, role: "user", content: text, citations: [] }]);
    setLoading(true);
    try {
      const res = await api.sendChat(text);
      setMessages((m) => [...m, res]);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to get an answer");
      setMessages((m) => [
        ...m,
        { id: `err_${Date.now()}`, role: "assistant", content: "Sorry, something went wrong. Please try again.", citations: [] },
      ]);
    } finally {
      setLoading(false);
    }
  }, []);

  const clear = useCallback(async () => {
    await api.clearHistory();
    setMessages([]);
    toast.success("Chat cleared");
  }, []);

  return { messages, loading, send, clear };
};
